module.exports = __webpack_public_path__ + "static/media/event_24px.f799600f.svg";